// Barra inferior del carrito: solo aparece con artículos. «Ver carrito» y «Cobrar» abren el cajón.
import { ShoppingCart } from 'lucide-react';
import { formatMoneyCents } from '@/shared/lib/format/money';
import type { CartSummary } from '../lib/accessoriesCart';

export function unitsLabel(units: number): string {
    return `${String(units)} ${units === 1 ? 'artículo' : 'artículos'}`;
}

export function AccessoriesCartBar({
    summary,
    onOpen,
}: {
    summary: CartSummary;
    onOpen: () => void;
}) {
    if (summary.unitsCount === 0) return null;
    return (
        <div
            role="status"
            aria-label="Resumen del carrito"
            className="flex flex-none items-center gap-3 border-t border-border bg-card px-4 py-2.5 shadow-[0_-4px_12px_rgba(0,0,0,0.06)]"
        >
            <ShoppingCart className="size-4 text-muted-foreground" aria-hidden />
            <span className="text-[12.5px]">
                {unitsLabel(summary.unitsCount)} ·{' '}
                <strong className="tabular-nums">{formatMoneyCents(summary.subtotalCents)}</strong>
            </span>
            <div className="flex-1" />
            <button
                type="button"
                onClick={onOpen}
                className="rounded-md border border-border bg-card px-3 py-1.5 text-[12px] font-semibold hover:bg-accent"
            >
                Ver carrito
            </button>
            <button
                type="button"
                onClick={onOpen}
                className="rounded-md bg-primary px-3 py-1.5 text-[12px] font-semibold text-primary-foreground hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-50"
            >
                Cobrar
            </button>
        </div>
    );
}
